<script lang="ts">
  import { onDestroy } from 'svelte';
  import type { PowerUpMessage } from '../../shared/protocol';
  import { powerUpTileStyle } from './chaos';
  import { PowerUpFeedback } from './power-up-feedback.svelte';

  const feedback = new PowerUpFeedback();
  onDestroy(() => feedback.dispose());
  export function show(message: PowerUpMessage, meId: string, nameOf: (id: string) => string): void {
    feedback.show(message, meId, nameOf);
  }
</script>

<span class="announcement" role="status" aria-live="polite" aria-atomic="true">
  {#key feedback.cue?.sequence}{feedback.cue?.announcement ?? ''}{/key}
</span>
{#if feedback.cue}
  {#key feedback.cue.sequence}
    <div
      class="power-up-feedback {feedback.cue.outcome}"
      data-kind={feedback.cue.kind}
      data-outcome={feedback.cue.outcome}
      style={powerUpTileStyle(feedback.cue.kind)}
      aria-hidden="true"
    ></div>
  {/key}
{/if}

<style>
  /* Anchored to the board card, never the tiles: no layout, hit testing or word-feedback changes. */
  .power-up-feedback {
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    border-radius: var(--theme-card-radius);
    color: var(--theme-power-up-feedback-color);
    border: var(--theme-power-up-feedback-border);
    box-shadow: var(--theme-power-up-feedback-shadow);
    animation: var(--theme-power-up-collect-animation);
  }
  .power-up-feedback::after {
    content: var(--pu-glyph);
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 24px;
    line-height: 1;
  }
  .hit {
    color: var(--theme-danger);
    animation: var(--theme-power-up-hit-animation);
  }
  .blocked {
    animation: var(--theme-power-up-blocked-animation);
  }
  .announcement {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
</style>
